import React, {useEffect, useState,memo} from 'react';
import {Head, MapReport} from "../../components";
import Container from "@mui/material/Container";
import {Box, CircularProgress} from "@mui/material";
import moment from 'moment-jalaali'
import Grid from "@mui/material/Grid";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionActions from '@mui/material/AccordionActions';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import {useDispatch, useSelector} from "react-redux";
import {period} from "../../actions";
import {useLocation, useNavigate} from "react-router-dom";
import PeriodAutoComplete from "../../components/Period";
import ReactFC from "react-fusioncharts";
import Api from "../../utils/api";
import PeriodMapExport from "./excel/map";
import PeriodSalesExport from "./excel/sales";
import queryString from 'query-string';

const PeriodReport = ( props ) => {


    const location = useLocation();
    const history = useNavigate();

    const dispatch = useDispatch();
    const  AppState  = useSelector(state => state);

    const [loading, setLoading] = useState(false);

    const [mapReport, setMapReport] = useState([]);
    const [chart, setChart] = useState({});
    const [chartData, setChartData] = useState({});



    const chartConfigs = {
        type: 'mscombi2d',// The chart type
        width: '100%', // Width of the chart
        height: '400', // Height of the chart
        dataFormat: 'json', // Data type
        dataSource: {
            "chart": {
                "caption": "گزارش میزان فروش",
                // "subCaption": "گزارش 30 روز گذشته",
                "yAxisName": "مبلغ به تومان",
                "theme": "fusion",
                "formatNumberScale" : '0',
                "decimalSeparator": ".",
                "thousandSeparator": ",",
            },
            "categories": [
                {
                    "category": chart.label
                }
            ],
            "dataset": [
                {
                    "seriesName": "تعداد فاکتور",
                    "renderAs": "line",
                    "data": chart.count
                },
                {
                    "seriesName": "مبلغ فروش",
                    "renderAs": "line",
                    "data": chart.price
                }
            ]
        }
    };

    useEffect(() => {
        if (AppState.period.ready !== 'success') {
            dispatch(period());
        }
    }, [AppState.period.ready]);



    const handleChangeSearchInputWithAutoComplete = (name, value) => {
        _makeQueryStringParams(name, value)
    }


    const query = queryString.parse(location.search);

    // state container
    const [params, setParams] = useState({
        month_id: query.month_id ? parseInt(query.month_id) : '',
        period_id: query.period_id ? parseInt(query.period_id) : '',
    });


    const handleRequest = () => {

        setLoading(true);

        new Api().get('/period/sales-daily-report', params).then((response) => {
            if (typeof response != "undefined") {

                setChartData(response);

                let chart = {
                    label: [],
                    price: [],
                    count: []
                };

                response.map((r, key) => {
                    chart.label.push({'label' : moment(r.label, 'YYYY/MM/DD HH:mm:ss').locale('fa').format('jM/jDD')});
                    chart.price.push({'value' : r.total_pay});
                    chart.count.push({'value' : r.total_count});
                });

                setChart(chart);
                setLoading(false);
            }
        })

        new Api().get('/period/mapReport', params).then((response) => {
            if (typeof response !== "undefined") {
                setMapReport(response);
                setLoading(false)
            }
        })
    }

    useEffect(() => {

        handleRequest();
        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, [
        params.month_id,
        params.period_id,
    ]);


    useEffect(() => {

        let n_params = params;

        const keys = Object.keys(query);

        for (let i = 0; i < keys.length; i++) {
            switch (keys[i]) {
                case 'month_id':
                    if (n_params.month_id !== query.month_id) {
                        n_params.month_id = query.month_id;
                    }
                    break;
                case 'period_id':
                    if (n_params.period_id !== query.period_id) {
                        n_params.period_id = query.period_id;
                    }
                    break;
                default:
                    break;
            }
        }

        setParams({...n_params});

    }, [
        query.period_id,
        query.month_id,
    ]);



    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'month_id':
                n_params.month_id = value;
                break;
            case 'period_id':
                n_params.period_id = value;
                break;

        }

        // create url
        let url = '?';
        url += `&month_id=${n_params.month_id}`;
        url += `&period_id=${n_params.period_id}`;


        history(`/period/report/${url}`);

    };



    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'گزارش دوره ها', 'description': 'گزارش دوره ها' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={true}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography><b>جستجو</b></Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <PeriodAutoComplete list={AppState.period.data} onChange={(name, value) => handleChangeSearchInputWithAutoComplete(name, value)}/>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                {!loading && mapReport && <PeriodMapExport entities={mapReport} period_id={params.period_id} />}
                {chartData.length > 0 && <PeriodSalesExport entities={chartData} period_id={params.period_id} />}
            </div>
            <Box style={{ margin: '30px 0', minHeight: '400px', position: 'relative'}}>
                {loading ? <CircularProgress className='centeral' size={15} color="secondary" /> : <ReactFC {...chartConfigs}/>}
            </Box>
            {!loading && mapReport && <MapReport list={mapReport}/>}
        </Container>

    );
}


export default memo(PeriodReport);
